
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { MediaType, mediaTypeRegExp } from '@/utils/mediaType'

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class AppInputFile extends Vue {
    @Prop() public mediaType!: MediaType
    @Prop() public numberOfFiles!: number
    @Prop({ default: '' }) public title!: string
    @Prop({ default: '' }) public error!: string
    @Prop({ default: false }) public submitted!: boolean
    @Prop({ default: undefined }) public tooltip?: string

    get multiple() {
        return this.numberOfFiles > 1
    }

    get description() {
        if (this.submitted) {
            return 'Arquivo submetido'
        } else {
            return 'Escolha um arquivo'
        }
    }

    get icon() {
        if (this.submitted) {
            return 'check'
        } else {
            return 'file-upload'
        }
    }

    get hasError() {
        return this.error && this.error.length > 0
    }

    get hasTitle() {
        return this.title && this.title.length > 0
    }

    public launchFilePicker() {
        (this.$refs.file as any).click()
    }

    @Emit('onFileChange')
    public async onFileChange(e: Event) {
        const { files } = e.target as any
        const filesContent: File[] = []

        if (files.length > 0) {
            for (const file of files) {
                const regex = mediaTypeRegExp(this.mediaType)

                if (!file.type.match(regex)) {
                    window.alert(
                        `O arquivo deve ser do formato ${regex}`,
                    )

                    return undefined
                }

                filesContent.push(file)
            }
        }

        if (filesContent.length === this.numberOfFiles) {
            this.submitted = true
        }

        return filesContent
    }
}
